import { useCallback } from 'react';
import type { DemoOption } from '@shared/schemas/admin-access';
import { describeImpersonationError, useStartDemo } from '../../hooks/useImpersonation';

interface DemoStartActionOptions {
  /** Shows the failure; each palette keeps its own surface (toast or inline error). */
  onError: (message: string) => void;
  /** Runs after the demo session starts, before the page navigates home. */
  beforeNavigate?: () => void;
}

/**
 * Start a demo session as `option`, then land on `/`. Resolves true once
 * navigation was triggered, false after reporting the failure via `onError`.
 */
export function useDemoStartAction({ onError, beforeNavigate }: DemoStartActionOptions) {
  const startDemo = useStartDemo();
  return useCallback(async (option: DemoOption): Promise<boolean> => {
    try {
      await startDemo(option);
      beforeNavigate?.();
      window.location.assign('/');
      return true;
    } catch (error) {
      onError(describeImpersonationError(error));
      return false;
    }
  }, [startDemo, onError, beforeNavigate]);
}
